import BigButton from "components/atoms/buttons/BigButton";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { TransferData } from "./TransferContainer";
import * as s from "styles/ModalCommonStyled";
import * as as from "../AccountStyled";
import Input from "components/atoms/input/Input";
import OrganizationImg from "assets/images/transfer_organization.png";
import { UseMutationButton } from "components/atoms/buttons/useMutationButton";
import * as bt from "components/atoms/buttons/ButtonStyled";
import { useState } from "react";
import { ValidateWord } from "components/atoms/text/Text";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";

interface Props {
  onClose: () => void;
  dataTransfer: TransferData;
  setDataTransfer: React.Dispatch<React.SetStateAction<TransferData>>;
  mutationCheckPasswordButtonProps: UseMutationButton;
  validateMsg: ValidateMsg;
}

export default function TransferPresenter(props: Props) {
  const { MutationButton, handleClick } =
    props.mutationCheckPasswordButtonProps;
  const [pwType, setPwType] = useState<"text" | "password">("text");
  return (
    <BigPopupTemplate title="Transfer Organization" onModal={props.onClose}>
      <as.TransferForm>
        <as.TranferFieldset>
          <ModalInput
            label="New CP Organization ID"
            essential
            validatedWord={props.validateMsg.isAccountName}
            isValidated={props.validateMsg.isAccountName !== ""}
          >
            <Input
              placeholder="Enter a CP organization ID"
              value={props.dataTransfer?.accountId || ""}
              maxLength={100}
              onChange={(e) =>
                props.setDataTransfer((transfer) => ({
                  ...transfer,
                  accountId: e.target.value,
                }))
              }
              autoComplete="off"
              name="transfer_organization"
              data-testid="account-transfer-transfer-transfer-organization-set-data-transfer"
            />
          </ModalInput>
          <ModalInput label="Your Login Email" essential>
            <Input
              placeholder="Please enter an email"
              value={props.dataTransfer?.email || ""}
              maxLength={100}
              disabled
            />
          </ModalInput>
          <ModalInput label="Your Password" essential>
            <Input
              type={pwType}
              placeholder="Please enter a password"
              value={props.dataTransfer?.password || ""}
              maxLength={100}
              onKeyDown={(e) => {
                setPwType("password");
                if (e.key === "Enter") {
                  handleClick();
                }
              }}
              autoComplete="new-password"
              name="transfer_password"
              onChange={(e) =>
                props.setDataTransfer((transfer) => ({
                  ...transfer,
                  password: e.target.value,
                }))
              }
              data-testid="account-transfer-transfer-transfer-password-set-data-transfer"
            />
          </ModalInput>
        </as.TranferFieldset>
        <as.TransferDescription>
          <h3>
            Transferring Organizations
            <small>
              You can relinquish ownership of an end user or sub-CP organization
              and transfer it to another one.
            </small>
          </h3>
          <img src={OrganizationImg} alt="" />
        </as.TransferDescription>
      </as.TransferForm>
      <as.EditButtonWrapper>
        <s.ButtonWrapper>
          <BigButton
            buttonType="cancel"
            label="Cancel"
            onClickBtn={props.onClose}
            style={{ minWidth: 0 }}
            data-testid="account-transfer-transfer-button-close"
          />

          <MutationButton id="dw_account_button__save" style={{ minWidth: 0 }}>
            <bt.ButtonLabel>Transfer</bt.ButtonLabel>
          </MutationButton>
        </s.ButtonWrapper>
      </as.EditButtonWrapper>
    </BigPopupTemplate>
  );
}
